import { api } from './api'
import type {
  Tender,
  TenderFilters,
  TenderListParams,
  PaginatedTenders,
} from '@/types/tenders'

export const tendersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTenderFilters: builder.query<{ data: TenderFilters }, void>({
      query: () => '/tenders/filters',
    }),

    listTenders: builder.query<PaginatedTenders, TenderListParams>({
      query: (params) => {
        const search = new URLSearchParams()
        if (params.sector) search.set('sector', params.sector)
        if (params.country) search.set('country', params.country)
        if (params.status) search.set('status', params.status)
        if (params.page) search.set('page', String(params.page))
        if (params.perPage) search.set('perPage', String(params.perPage))
        return `/tenders?${search.toString()}`
      },
      providesTags: [{ type: 'Tenders', id: 'LIST' }],
    }),

    getTender: builder.query<{ data: Tender }, string>({
      query: (id) => `/tenders/${id}`,
      providesTags: (result) =>
        result ? [{ type: 'Tenders', id: result.data.id }] : [],
    }),
  }),
})

export const {
  useGetTenderFiltersQuery,
  useListTendersQuery,
  useGetTenderQuery,
} = tendersApi
